module.exports = __webpack_public_path__ + "static/img/pg2.b62e9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pg2.png
// module id = cp7a
// module chunks = 1